import { createFileRoute } from '@tanstack/react-router'

import { useAdminRedeemable } from '@repo/common/queries/admin/redeem'

import { UnderlyingRedemptionsTable } from '@/components/Redeem/UnderlyingRedemptionsTable'
import { withStaticTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/redeem/$id/underlying')({
  component: UnderlyingRedemptionsPage,
  head: withStaticTitle('Underlying Redemptions'),
})

function UnderlyingRedemptionsPage() {
  const { id } = Route.useParams()
  const { data: redeemable } = useAdminRedeemable(id)

  if (!redeemable) return null

  return (
    <UnderlyingRedemptionsTable
      underlyingRedemptions={redeemable.underlying_redemptions.nodes}
      totalCount={redeemable.underlying_redemptions.total_count}
    />
  )
}
